/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InformationExtractionSchema
 */
export interface InformationExtractionSchema {
  /**
   *
   * @type {number}
   * @memberof InformationExtractionSchema
   */
  readonly id: number;
  /**
   *
   * @type {Array<number>}
   * @memberof InformationExtractionSchema
   */
  readonly fields: Array<number>;
}

/**
 * Check if a given object implements the InformationExtractionSchema interface.
 */
export function instanceOfInformationExtractionSchema(value: object): value is InformationExtractionSchema {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function InformationExtractionSchemaFromJSON(json: any): InformationExtractionSchema {
  return InformationExtractionSchemaFromJSONTyped(json, false);
}

export function InformationExtractionSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionSchema {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fields: json['fields'],
  };
}

export function InformationExtractionSchemaToJSON(
  value?: Omit<InformationExtractionSchema, 'id' | 'fields'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
